import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";
import { useContext } from "react";
import { AppStorage } from "../Utils/Context/AppContext";
import Logo from "../images/LOGO.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import axios from "../Utils/Request/axios";

function MaintenancePage() {
  const { checkMaintenanceMode, setUserToken } = useContext(AppStorage);
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const changeLanguage = (event) => {
    const language = event.target.value;
    i18n.changeLanguage(language);
    localStorage.setItem("selectedLanguage", language);
  };

  const logout = () => {
    setUserToken("");
    localStorage.removeItem("p_u_t");
    localStorage.removeItem("userInfo");
    delete axios.defaults.headers.common.Authorization;
    navigate("/", { replace: true });
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "grid", placeItems: "center", position: "relative", background: "linear-gradient(135deg, #173745 0%, #315f72 52%, #b58a3d 100%)" }}>
      <Select
        value={i18n.language}
        onChange={changeLanguage}
        size="small"
        sx={{ position: "absolute", top: 24, right: 24, minWidth: 120, color: "#fff", borderColor: "rgba(255,255,255,.7)", "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,.7)" }, "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#fff" }, "& .MuiSvgIcon-root": { color: "#fff" } }}
      >
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="ar">العربية</MenuItem>
      </Select>
      <Box sx={{ maxWidth: 570, width: "100%", overflow: "hidden", textAlign: "center", borderRadius: 5, background: "#fff", boxShadow: "0 25px 70px rgba(0,0,0,.28)", p: 3 }}>
        <Box sx={{ px: 3, py: 0.5, borderBottom: "1px solid #edf0f1", background: "#fff" }}>
          <Box component="img" src={Logo} alt="Doryal" sx={{ display: "block", width: 285, maxWidth: "88%", mx: "auto" }} />
        </Box>
        <Box dir={i18n.language === "ar" ? "rtl" : "ltr"} sx={{ p: { xs: 4, sm: 6 } }}>
          <Box sx={{ width: 74, height: 74, mx: "auto", mb: 3, display: "grid", placeItems: "center", borderRadius: "50%", background: "#fff1d6" }}>
            <ConstructionIcon sx={{ fontSize: 42, color: "#bf9140" }} />
          </Box>
          <Typography variant="h3" fontWeight={800} color="#243844" gutterBottom>{t("Maintenance heading")}</Typography>
          <Typography sx={{ fontSize: 17, lineHeight: 1.65, color: "#5e6e76", mb: 4 }}>
            {t("Maintenance description")}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", gap: 1.25, flexWrap: "wrap" }}>
            <Button onClick={checkMaintenanceMode} variant="contained" sx={{ px: 3, py: 1.15, background: "#365b6d", "&:hover": { backgroundColor: "#284958" } }}>
              {t("Check again")}
            </Button>
            <Button onClick={logout} variant="outlined" color="inherit" sx={{ px: 3, py: 1.15 }}>
              {t("Logout")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default MaintenancePage;
